import React, { useState } from 'react';
import { TextInput } from 'apps/sigma2-ui/src/components/ui/TextInput';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { convertTranslatedContentToReactNode } from 'apps/sigma2-ui/src/lib/hooks/useTranslation';
import { getTranslatedContentAsString } from 'libs/end-to-end/src/translation-content';

export interface AreYouSureDialogProps {
  onCancel: () => void;
  onSure: () => void;
  bodyTranslatedContent: TranslatedContent;
  disableInputs: boolean;
}

export const AreYouSureDialog: React.FC<AreYouSureDialogProps> = ({
  onSure,
  onCancel,
  disableInputs,
  bodyTranslatedContent,
}) => {
  const language = useLanguage();
  const [deleteConfirmText, setDeleteConfirmText] = useState('');

  return (
    <div className="relative z-overlay">
      <div className="fixed inset-0 bg-black bg-opacity-25" />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-12px">
            <S2Typography
              variant={'headline-5-alt'}
              translatedContent={language.areYouSureTitle()}
            />

            <div className="mt-2">
              <S2Typography
                variant={'headline-7-alt'}
                translatedContent={bodyTranslatedContent}
              />
              <S2Typography
                variant={'headline-7-alt'}
                translatedContent={language.areYouSureConfirmationPrompt()}
              />

              <p className="text-sm text-gray-500"></p>
              <TextInput
                id="deleteConfirmText"
                type="text"
                name="deleteConfirmText"
                data-qa="deleteConfirmText"
                aria-label="deleteConfirmText"
                onChange={(e) => setDeleteConfirmText(e.currentTarget.value)}
                autoFocus
                value={deleteConfirmText}
                disabled={disableInputs}
                required
                autoComplete="off"
              />
            </div>

            <div className="mt-4">
              <Spacing direction={'horizontal'} size={'md'}>
                <Button
                  variant={'destructive'}
                  disabled={
                    disableInputs ||
                    deleteConfirmText.toLocaleLowerCase() !==
                      getTranslatedContentAsString(
                        language.areYouSureConfirmButton(),
                      ).toLocaleLowerCase()
                  }
                  behavior={{
                    type: 'onClick',
                    onClick: () => {
                      onSure();
                    },
                  }}
                >
                  {convertTranslatedContentToReactNode(
                    language.areYouSureConfirmButton(),
                  )}
                </Button>

                <Button
                  variant={'outline'}
                  disabled={disableInputs}
                  behavior={{
                    type: 'onClick',
                    onClick: () => {
                      onCancel();
                    },
                  }}
                >
                  {convertTranslatedContentToReactNode(
                    language.areYouSureCancelButton(),
                  )}
                </Button>
              </Spacing>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
